const Card = require("../../entities/Cards/Card");
const {CardDeck, CivilCardTypes}  = require("../../Constants/Constants");

class TechnologyCard extends Card {
    // (version: of a technology the expansion changed, see Constants/CardVersions.js)
    constructor(technology, version){
        super(
            CardDeck.Civil,
            CivilCardTypes.Technology,
            technology.GetType(),
            technology.GetName(), 
            technology.GetAge(),
            "",
            {
                playerStateAltering:
                (playerState) => {
                    //Do stuff
                }
            }
        )
        this.Technology = technology.GetInstance(version);
    }
}

module.exports = TechnologyCard;